/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isInstitutionId(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }
    let isValid = value.length === 3 && ValidCAInstitutionIds.includes(value);

    return isValid ? null : { invalidInstitutionId: true };
  };
}

export const ValidCAInstitutionIds = [
  '001',
  '002',
  '003',
  '004',
  '006',
  '010',
  '016',
  '030',
  '039',
  '117',
  '127',
  '177',
  '219',
  '245',
  '260',
  '269',
  '270',
  '308',
  '309',
  '310',
  '315',
  '320',
  '338',
  '340',
  '352',
  '509',
  '540',
  '608',
  '614',
  '618',
  '623',
  '809',
  '815',
  '819',
  '828',
  '829',
  '837',
  '839',
  '842',
  '865',
  '879',
  '889',
  '899',
];
